import React, { useState, useEffect } from "react";
import { InputText, SelectDropdown } from "commons/input-controls";
import AlignButtons from "pages/report-constructor/align-buttons/align-buttons";
import FontBase from "../font-base/font-base";
import DataFieldsContainer from "pages/report-constructor/items/data-fields/data-fields.container";
import SaveButton from "pages/report-constructor/items/save-button/save-button";
import s from "./table-component.module.scss";

const TableComponent = (props) => {
  
    const [parameters, setParameters] = useState(props.parameters && props.parameters ? props.parameters : null);

    useEffect(() => {
        setParameters(props.parameters && props.parameters ? props.parameters : null);
    }, [props]);
    

    const updateParameters = (type, parameter, value) => {
        let params = parameters;
        let fontParams = {...params[type]}
        fontParams[parameter] = value;
        params[type] = fontParams
        if(value === ''){
            delete params[type][parameter];
        }
        if(parameter == 'dateField'){
            params[type].fields.length = 1;
        }
        else if(parameter == 'fields' && params[type].fields.length > 1){
            delete params[type].dateField;
        }
        props.updateComponent(props.index, params)
    }

    const saveTable = () => {
        let type = 'TABLE';
        props.updateTemplateComponents(parameters, type)
    }

    const align = (align) => {
        let params = {...parameters};
        params.ALIGNMENT = align;
        props.updateComponent(props.index, params)
        //setParameters(params);
        //setRerender(!rerender);
    }

    const removeParameter = () => {
        props.removeParameter(props.index, 'FONT_PARAMETERS');
    }

    const addParameter = () => {
        props.addParameter(props.index, 'FONT_PARAMETERS');
    }

    return (
        <div className={s.TableComponent}>
            <AlignButtons getValue={props.getValue} alignItems={align} alignment={parameters.ALIGNMENT ? parameters.ALIGNMENT : null}/>
            <div className={s.TableBlock}>
                <FontBase 
                        readOnly={props.isReadOnly} 
                        getValue={props.getValue} 
                        fonts={props.fonts} 
                        parameters={parameters && parameters.FONT_PARAMETERS ? parameters.FONT_PARAMETERS :null} 
                        colors={props.colors} 
                        updateParameters={updateParameters} 
                        type={'FONT_PARAMETERS'}
                        removeParameter={removeParameter} 
                        addParameter={addParameter}
                />
            </div>
           
            <div className={s.selectData}>
                <DataFieldsContainer 
                                    parameters={parameters.ANALYTICS_PARAMETERS} 
                                    type={'ANALYTICS_PARAMETERS'}
                                    availableFields={['first', 'second', 'dateField']}
                                    setParameters={updateParameters}
                                    readOnly={props.isReadOnly}
                                    articles={{first: "VERTICAL", second: "HORIZONTAL", dateField: "VERTICAL"}}
                                />
            </div>
        </div>
    )
}

export default TableComponent;